import UAParser from 'ua-parser-js'
import queryString from 'query-string'

const parser = new UAParser()
const deviceInfo = parser.getResult()
let isMobile = false
let isTablet = false
let isAndroid = false
let isIOS = false
let osName = ''
let deviceModel = ''
let osVersion = ''
if (deviceInfo) {
  if (deviceInfo.device && deviceInfo.device.type) {
    isMobile = deviceInfo.device.type.toLowerCase() === 'mobile'
    isTablet = deviceInfo.device.type.toLowerCase() === 'tablet'
    deviceModel = deviceInfo.device.model ? deviceInfo.device.model.toLowerCase() : 'None'
  }
  if (deviceInfo.os && deviceInfo.os.name) {
    isAndroid = deviceInfo.os.name.toLowerCase() === 'android'
    isIOS = deviceInfo.os.name.toLowerCase() === 'ios'
    osName = isAndroid ? 'Android' : isIOS ? 'iOS' : 'Web App'
    osVersion = deviceInfo.os.version.toLowerCase()
  }
}

const params = queryString.parse(location.search)
if (params.devsim === 'true') {
  let selectedDevice = window.localStorage.getItem('selectedDevice')
  selectedDevice = selectedDevice !== 'null' ? selectedDevice : params.device
  if (selectedDevice === 'devsimAndroid' || selectedDevice === 'devsimandroidWeb') {
    isAndroid = true
  } else {
    isAndroid = false
  }
}

export default {
  isMobile,
  isTablet,
  isAndroid,
  isIOS,
  osName,
  osVersion,
  deviceModel,
  ...deviceInfo
}



// WEBPACK FOOTER //
// ./src/modules/util/deviceInfo.js